import {
	IRestExercise,
	IRestExerciseAnswer,
	IRestExerciseStudent,
	IRestExerciseStudentAnswer,
	EExerciseStatus,
} from '../../../common/rest/exercises/exercisesRest';
import {
	EXERCISES_CLEAR_ANSWERS,
	EXERCISES_REMOVE_ANSWER,
	EXERCISES_SET_ANSWER,
	EXERCISES_SET_DATA,
	EXERCISES_SET_LOAD_FAILED,
	ISetExercisesLoadFailedAction,
	EXERCISES_SET_EXERCISE,
	EXERCISES_SET_GENERATING,
	EXERCISES_SET_STUDENTS,
	EXERCISES_SET_STATUS,
	EXERCISES_SET_GENERATE_FAILED,
	ISetExerciseStatusAction,
	ISetExerciseGenerateFailedAction,
	IClearExerciseAnswersAction,
	IRemoveExerciseAnswerAction,
	ISetExerciseAction,
	ISetExerciseAnswerAction,
	ISetExerciseGeneratingAction,
	ISetExercisesDataAction,
	ISetExerciseStudentsAction,
	TAudioExercisesState,
	EXERCISES_SET_NATIVE,
	ISetExerciseNativeAction,
	TExerciseNativeState,
} from './types';

export const setExerciseNativeAction = (exerciseId: number, native: TExerciseNativeState): ISetExerciseNativeAction => ({
	type: EXERCISES_SET_NATIVE,
	exerciseId,
	native,
});

export const setExercisesDataAction = (audioId: number, data: TAudioExercisesState): ISetExercisesDataAction => ({
	type: EXERCISES_SET_DATA,
	audioId,
	data,
});

export const setExerciseAction = (audioId: number, exercise: IRestExercise): ISetExerciseAction => ({
	type: EXERCISES_SET_EXERCISE,
	audioId,
	exercise,
});

export const setExerciseGeneratingAction = (audioId: number, promptId: number, generating: boolean): ISetExerciseGeneratingAction => ({
	type: EXERCISES_SET_GENERATING,
	audioId,
	promptId,
	generating,
});

export const setExerciseAnswerAction = (audioId: number, answer: IRestExerciseAnswer): ISetExerciseAnswerAction => ({
	type: EXERCISES_SET_ANSWER,
	audioId,
	answer,
});

export const removeExerciseAnswerAction = (audioId: number, exerciseId: number, questionIndex: number): IRemoveExerciseAnswerAction => ({
	type: EXERCISES_REMOVE_ANSWER,
	audioId,
	exerciseId,
	questionIndex,
});

export const clearExerciseAnswersAction = (audioId: number, exerciseId: number): IClearExerciseAnswersAction => ({
	type: EXERCISES_CLEAR_ANSWERS,
	audioId,
	exerciseId,
});

export const setExerciseStudentsAction = (
	audioId: number,
	students: IRestExerciseStudent[],
	answers: IRestExerciseStudentAnswer[]
): ISetExerciseStudentsAction => ({
	type: EXERCISES_SET_STUDENTS,
	audioId,
	students,
	answers,
});

export const setExercisesLoadFailedAction = (audioId: number, failed: boolean): ISetExercisesLoadFailedAction => ({
	type: EXERCISES_SET_LOAD_FAILED,
	audioId,
	failed,
});

export const setExerciseStatusAction = (audioId: number, exerciseId: number, status: EExerciseStatus): ISetExerciseStatusAction => ({
	type: EXERCISES_SET_STATUS,
	audioId,
	exerciseId,
	status,
});

export const setExerciseGenerateFailedAction = (audioId: number, promptId: number, failed: boolean): ISetExerciseGenerateFailedAction => ({
	type: EXERCISES_SET_GENERATE_FAILED,
	audioId,
	promptId,
	failed,
});
